var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.224,
    height: 38.5,
    viewBox: "0 0 38.224 38.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-551.644 -515.723)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.612,
    cy: 5.647,
    rx: 18.612,
    ry: 5.647,
    transform: "translate(552.144 542.428)",
    fill: "none",
    stroke: "#af995c",
    strokeWidth: 1,
    opacity: 0.195
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.561,553.348c-4.928,0-8.922,1.074-8.922,2.4s3.995,2.4,8.922,2.4,8.922-1.074,8.922-2.4S578.489,553.348,573.561,553.348Z",
    transform: "translate(-2.805 -8.446)",
    fill: "none",
    stroke: "#af995c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(563.564 515.723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.093,515.723a3.641,3.641,0,1,0,3.641,3.64A3.641,3.641,0,0,0,575.093,515.723Z",
    transform: "translate(-567.899 -515.723)",
    fill: "#2d2f29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.87,531.359v7.774a1.646,1.646,0,0,0,1.649,1.642h1.545l.828,7.959a1.5,1.5,0,0,0,1.49,1.342h3.369a1.5,1.5,0,0,0,1.489-1.342l.829-7.959h1.544a1.639,1.639,0,0,0,1.641-1.642v-7.774C581.253,525.075,566.87,525.075,566.87,531.359Z",
    transform: "translate(-566.87 -518.175)",
    fill: "#2d2f29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserLocation);
export default __webpack_public_path__ + "static/media/icon_user_location.df0ad27f2a8fbed87b91c32f1bec3637.svg";
export { ForwardRef as ReactComponent };